import React from "react";
import HeaderComponentV2 from "../HeaderComponentV2";


type HeaderToDisplayProps = {
  onShowSide: () => void;
  setDropdownOpen: (val: boolean) => void;
}

export const HeaderToDisplay: React.FC<HeaderToDisplayProps> = ({
  onShowSide,
  setDropdownOpen,
}) => {
  return (
    <>
        <HeaderComponentV2
          onShowSide={onShowSide}
          setDropdownOpen={setDropdownOpen}
        />

    </>
  );
};
